import moment from 'moment-timezone';

export class EnterpriseDashboardPerformanceLocationMonthlyChartData {
	public date: Date;
	public costAvoidance: number;

	constructor(enterpriseDashboardPerformanceLocationMonthlyChartData?: EnterpriseDashboardPerformanceLocationMonthlyChartData) {
		Object.assign(this, enterpriseDashboardPerformanceLocationMonthlyChartData);

		this.date = this.date ? new Date(moment(this.date).format('MMM DD, YYYY 00:00:00 a')) : this.date;
	}
}
